import React from "react";

import Label from "@busbud/design-system-components/dist/Label";

import { useStyles } from "./location-info.styles";

interface Props {
  title?: string;
  subtitle?: React.ReactNode;
}

export const LocationInfo: React.FC<Props> = ({ title, subtitle }) => {
  const { classes } = useStyles();
  return (
    <>
      {!!title && (
        <Label className={classes.label} component="div">
          {title}
        </Label>
      )}
      {subtitle && typeof subtitle === "string" ? (
        <Label
          className={classes.label}
          component="div"
          color="text.secondary.opaque"
          size="lg"
        >
          {subtitle}
        </Label>
      ) : (
        subtitle
      )}
    </>
  );
};
